var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-template-card" }, [
    _c("div", { staticClass: "automation-template-card__default-content" }, [
      _c(
        "header",
        { staticClass: "automation-template-card__header" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.template.connectorTooltip,
                placement: "bottom-start",
                arrow: false,
                disabled: !_vm.template.connectorTooltip
              }
            },
            [
              _c(
                "div",
                { staticClass: "automation-template-card__connector" },
                [_vm._t("connector")],
                2
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "typographies-heading-h3 automation-template-card__title"
        },
        [_vm._v("\n            " + _vm._s(_vm.template.title) + "\n        ")]
      ),
      _vm._v(" "),
      _vm.template.isPopular
        ? _c(
            "footer",
            { staticClass: "automation-template-card__footer" },
            [
              _c("CompassTag", { attrs: { color: "yellow", size: "small" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.translations.labelFlag) +
                    "\n            "
                )
              ])
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "automation-template-card__hover-content" },
      [
        _c(
          "p",
          {
            staticClass:
              "automation-template-card__description typographies-paragraph-medium-regular"
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.template.description) + "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c("CompassButton", {
          staticClass: "automation-template-card__button",
          attrs: {
            label: _vm.translations.useTemplate,
            loading: _vm.isLoading
          },
          on: { click: _vm.handleCreateAutomationWithTemplate }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }